import { type IntlShape } from 'react-intl';

export function deriveNameFromEmail(email: string): {
  firstName: string;
  lastName: string;
} {
  const localPart = email.split('@')[0] ?? 'User';
  const parts = localPart.split(/[._-]/);
  const firstName = parts[0] || localPart;
  const lastName = parts.length > 1 ? parts[1] || localPart : localPart;
  return { firstName, lastName };
}

export function getBookingErrorMessage(err: unknown, intl: IntlShape): string {
  return err instanceof Error
    ? err.message
    : intl.formatMessage({
        id: 'E2430AYOud',
        defaultMessage: 'Booking failed. Please try again.',
      });
}

export function formatSlotDateTime(
  intl: IntlShape,
  slotStartMillisUtc: number | undefined,
  timezone: string
): string | null {
  if (slotStartMillisUtc === undefined) return null;
  const date = new Date(slotStartMillisUtc);
  const dateLabel = intl.formatDate(date, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: timezone,
  });
  const timeLabel = intl.formatTime(date, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
  });
  return `${dateLabel}, ${timeLabel}`;
}
